import React from 'react'
import Preheader from './Preheader'
import Parters from './Parters'
import Footer from './Footer'
import vaibhav from './playerimg/vaibhav r.jpg'
import pankaj from './playerimg/pankaj j.jpg'
import keshav from './playerimg/keshav d.jpg'
import hiten from './playerimg/hiten d.jpg'
import prince from './playerimg/prince y.jpg'
import rahul from './playerimg/rahul c.jpg'
import deepak from './playerimg/deepak p.jpg'
import rahuld from './playerimg/rahul d.jpg'
import piyash from './playerimg/piyash c.jpg'
import parth from './playerimg/parth b.jpg'
import nitesh from './playerimg/nitesh s.jpg'
import ajay from './playerimg/ajay r.jpg'
import ruveer from './playerimg/ruveer k.jpg'
import aryan from './playerimg/aryan d.jpg'
import parikshit from './playerimg/parikshit b.jpg'
import ayush from './playerimg/ayush k.jpg'
import aatre from './playerimg/aatre t.jpg'
import pradyuman from './playerimg/pradyuman s.jpg'
import varun from './playerimg/varun V.jpg'
import pratap from './playerimg/Pratap b.jpg'
import dhruv from './playerimg/dhruv k.jpg'
import shivam from './playerimg/Shivam g.jpg'
import himmat from './playerimg/himmat singh.jpg'
// import player1 from './navineet.jpg'
// import player2 from './playerimg/14 karan yadav (1).jpg'
// import player4 from './playerimg/02 robin chaudhary.jpg'

// import player5 from './playerimg/15 pankaj.jpg'
// import player6 from './playerimg/03 harsh dhaka.jpg'
// import player7 from './playerimg/07 vishal patil.jpg'
// import player8 from './playerimg/08 shakti chaudhary.jpg'
// import player9 from './playerimg/11 lakshya tomer.jpg'
// import player10 from './playerimg/10 lucky kumar.jpg'
// import player11 from './playerimg/04 arjun singh.jpg'
// import player12 from './playerimg/05 abhishek dangi.jpg'
import { Helmet } from 'react-helmet'
// import team1 from './playerimg/harendra kumar.jpg'

export default function Squad() {
  return (
   <>
   <Helmet>
        <title>
        Meet the New Delhi Tigers Players - Names, Allrounders, Bowllers, and Batsman


        </title>
        <meta
          name="title"
          content="Meet the New Delhi Tigers Players - Names, Allrounders, Bowllers, and Batsman

"
        />
        <meta
          name="keywords"
          content=" 
 


New Delhi Tigers players
New Delhi Tigers players name
players of New Delhi Tigers
New Delhi Tigers Allrounders
New Delhi Tigers Bowllers
New Delhi Tigers Batsman
"
        />

        <meta
          name="description"
          content="Explore the complete squad of New Delhi Tigers, featuring top players' names, allrounders, bowllers, and batsman. Get to know the talented team members who make New Delhi Tigers a formidable force in DPLT20 League. Discover their skills and contributions to the team.
          

"
        />

        <link rel="canonical" href="https://newdelhitigers/squad" />
      </Helmet>

     <Preheader/>
   <div class="container-fluid p-0">
        <div class="breadcrumb-bg">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                <div className="newheading1">
  <h5>Squad</h5>
  <div className="line"></div>
</div>          
                </ol>
            </nav>
        </div>
        </div>
<section className='playersquad'>
    
<div className='container-fluid'>
      <div className='row'>
        <div className='col-md-3 col-12'>
            <img src={himmat} className='img-fluid'/>
        </div>

        <div className='col-md-3 col-12'>
            <img src={vaibhav} className='img-fluid'/>
        </div>
       
        <div className='col-md-3 col-12'>
            <img src={pankaj} className='img-fluid'/>
        </div>
        <div className='col-md-3 col-12'>
            <img src={keshav} className='img-fluid'/>
        </div>
        <div className='col-md-3 col-12'>
            <img src={hiten} className='img-fluid'/>
        </div>
        <div className='col-md-3 col-12'>
            <img src={prince} className='img-fluid'/>
        </div>
        <div className='col-md-3 col-12'>
            <img src={rahul} className='img-fluid'/>
        </div>
        <div className='col-md-3 col-12'>
            <img src={rahuld} className='img-fluid'/>
        </div>
        <div className='col-md-3 col-12'>
            <img src={piyash} className='img-fluid'/>
        </div>

        <div className='col-md-3 col-12'>
            <img src={parth} className='img-fluid'/>
        </div>


        <div className='col-md-3 col-12'>
            <img src={nitesh} className='img-fluid'/>
        </div>

        <div className='col-md-3 col-12'>
            <img src={ajay} className='img-fluid'/>
        </div>
        <div className='col-md-3 col-12'>
            <img src={ruveer} className='img-fluid'/>
        </div>
        <div className='col-md-3 col-12'>
            <img src={aryan} className='img-fluid'/>
        </div>
        <div className='col-md-3 col-12'>
            <img src={parikshit} className='img-fluid'/>
        </div>
        <div className='col-md-3 col-12'>
            <img src={ayush} className='img-fluid'/>
        </div>
        <div className='col-md-3 col-12'>
            <img src={aatre} className='img-fluid'/>
        </div>
        <div className='col-md-3 col-12'>
            <img src={pradyuman} className='img-fluid'/>
        </div>
        <div className='col-md-3 col-12'>
            <img src={varun} className='img-fluid'/>
        </div>
        <div className='col-md-3 col-12'>
            <img src={pratap} className='img-fluid'/>
        </div>
        <div className='col-md-3 col-12'>
            <img src={dhruv} className='img-fluid'/>
        </div>
        <div className='col-md-3 col-12'>
            <img src={shivam} className='img-fluid'/>
        </div>

        <div className='col-md-3 col-12'>
            <img src={deepak} className='img-fluid'/>
        </div>
        

      </div>
        </div>
</section>

        <Parters/>
        <Footer/>
   
   </>
  )
}
